import { createStyles } from '@zn-material-ui'

export default createStyles({
  loading: {
    position: 'fixed',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: 999,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginLeft: '-20px', // loading的尺寸是40 * 40
    marginTop: '-20px',
  },
})
